import { OnInit } from '@angular/core';
import { HistoryService, ActionType, ServerName } from 'src/app/services/history.service';
import { AdminService } from 'src/app/services/admin.service';
import { DialogService, SnackType } from 'src/app/services/dialog.service';
var ServerResetComponent = /** @class */ (function () {
    function ServerResetComponent(historyS, adminS, dialog) {
        this.historyS = historyS;
        this.adminS = adminS;
        this.dialog = dialog;
        this.columns = [
            { name: 'Resultado', value: 'icon', icon: 'icon', color: this.styleIcon },
            { name: 'Servidor', value: 'server' },
            { name: 'O que', value: 'what' },
            { name: 'Quando', value: 'when' },
            { name: 'Quem', value: 'user' },
            { name: 'Observações', value: 'obs' },
        ];
        this.history = [];
        this.icons = {
            'undefined': 'help',
            'red': 'error',
            'yellow': 'warning',
            'green': 'check_circle'
        };
        this.serverList = [
            ServerName.BR,
            ServerName.PNP,
            ServerName.LATAM,
            ServerName.TPX,
            ServerName.MEXICO,
            ServerName.API
        ];
    }
    ServerResetComponent.prototype.ngOnInit = function () {
        this.getHistory();
    };
    ServerResetComponent.prototype.getHistory = function () {
        var _this = this;
        this.historyS.all()
            .subscribe(function (response) {
            _this.history = response
                .filter(function (history) { return history.what === ActionType.ResetServer; })
                .map(function (row) {
                if (row['user']) {
                    row['user'] = row['user']['name'] + ' [' + row['user']['email'] + ']';
                }
                if (row['when']) {
                    row['when'] = new Date(row['when']);
                }
                if (row['success']) {
                    row['icon'] = _this.icons['green'];
                }
                else {
                    row['icon'] = _this.icons['red'];
                }
                return row;
            });
        });
    };
    ServerResetComponent.prototype.styleIcon = function (row, that) {
        // colore a celula de acordo com o icon
        for (var _i = 0, _a = Object.keys(that.icons); _i < _a.length; _i++) {
            var key = _a[_i];
            if (that.icons[key] === row.icon) {
                return key;
            }
        }
    };
    ServerResetComponent.prototype.confirm = function () {
        this.dialog.modal('Tem certeza?', { this: this }, [{ text: 'Cancelar', close: true },
            { text: 'Reiniciar', close: true, callback: this.reset }]).subscribe(function (response) {
        });
    };
    ServerResetComponent.prototype.reset = function (that) {
        return that.adminS.reset(that.selected).subscribe(function (response) {
            that.dialog.snack('Servidor reiniciado', SnackType.Success);
            that.getHistory();
        }, function (err) {
            that.dialog.snack('Erro ao reiniciar servidor', SnackType.Error);
        });
    };
    return ServerResetComponent;
}());
export { ServerResetComponent };
